import React from 'react';

const About = () => {
  return (
    <>
      <section className="about-section inner-page">
        <div className="container">
          <h1>Our Partner</h1>
          <div className="partners-section">

  <div className="partners-category">
  
    <table className=''>
      <thead>
        <tr>
          <th>S.N</th>
          <th>Government Organization</th>
          <th>Name of Program</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>1</td>
          <td>District Panchayat Balaghat</td>
          <td>Shelf Help Groups (SHG)</td>
        </tr>
        <tr>
          <td>2</td>
          <td>State Social Welfare Advisory Board Bhopal, Madhya Pradesh</td>
          <td>Women Awareness Program</td>
        </tr>
        <tr>
          <td>3</td>
          <td>
            Science &amp; Technology Deptt., Govt. of MP. Vigyan Bhawan, Nehru
            Nagar, Bhopal
          </td>
          <td>
            1-Mushroom Spawn Production and Farming Training
            <br />
            2-Low Cost Roofing Technical Training
          </td>
        </tr>
        <tr>
          <td>4</td>
          <td>ASER Centre - New Delhi</td>
          <td>A Citizens’ Survey of Children Across India</td>
        </tr>
        <tr>
          <td>5</td>
          <td>Jan Abhiyan Perished, Balaghat, Madhya Pradesh</td>
          <td>Awareness Program</td>
        </tr>
        <tr>
          <td>6</td>
          <td>
            Assistant Project Administrator Integrated Tribal Development
            Project Baihar District Balaghat Madhya Pradesh
          </td>
          <td>Construction of biogas and vermin compost plant</td>
        </tr>
        <tr>
          <td>7</td>
          <td>
            Environmental Planning &amp; Coordination Organisation (EPCO) Bhopal
          </td>
          <td>Environmental awareness program</td>
        </tr>
      </tbody>
    </table>
  </div>
  <div className="partners-category">
    <h2>2. State Government</h2>
    <table>
      <thead>
        <tr>
          <th>S.N</th>
          <th>State Government</th>
          <th>Name of Program</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>1</td>
          <td>
            Panchayat and Social Justice Department Bhopal, Madhya Pradesh
          </td>
          <td>De-addiction awareness program</td>
        </tr>
        <tr>
          <td>2</td>
          <td>
            National Bank for Agriculture and Rural Development, Regional
            office, Bhopal, Madhya Pradesh
          </td>
          <td>
            1-Kishan Club (KC)
            <br />
            2-Capacity Building for Adoption of Technology (CAT)
            <br />
            3-Farmer Producer Company (FPC)
            <br />
            4-MEDP
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div className="partners-category">
    <h2>3. Central Government</h2>
    <table>
      <thead>
        <tr>
          <th>S.N</th>
          <th>Central Government</th>
          <th>Name of Program</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>1</td>
          <td>Central Social Welfare Board, New Delhi</td>
          <td>
            1-Family Counseling Centre
            <br />
            2-Condensed Courses of Education for Women
          </td>
        </tr>
        <tr>
          <td>2</td>
          <td>National Women's Commission, New Delhi</td>
          <td>Holding of Legal Awareness Programme</td>
        </tr>
        <tr>
          <td>3</td>
          <td>
            Office of the Development Commissioner (Handicrafts) Ministry of
            Textiles, GOI, West Block No.7 RK Puram, New Delhi-110066
          </td>
          <td>
            1-Artisan Card
            <br />
            2-Bamboo Toolkit Distribution Program
          </td>
        </tr>
        <tr>
          <td>4</td>
          <td>
            National Medicinal Plants Board, Ministry of Ayush, Government of
            India, Indian Red Cross Society (IRCS), New Delhi
          </td>
          <td>School Herbal Garden (SHG)</td>
        </tr>
        <tr>
          <td>5</td>
          <td>
            National Council of Rural Institutes (NCRI), Ministry of Human
            Resource Development, Government of India, Hyderabad
          </td>
          <td>
            Micro Planning for training of grassroots level farmers in the
            scenario of climate change &amp; fed agriculture
          </td>
        </tr>
        <tr>
          <td>6</td>
          <td>Ministry of Tribal Affairs, Government of India, New Delhi</td>
          <td>
            Credit need of Baiga Tribal Women and Role of SHGs &amp; Theft and
            Credit in Balaghat District of Madhya Pradesh
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

        </div>
      </section>

     
    </>
  );
};

export default About;
